module.exports = __webpack_public_path__ + "img/20190730163839158.a0722f28.png";